const certificateStatusRA=
    {
        es: [
            {code:'ALL', name: 'Cualquier Estado'},
            {code:'PENDINGAPP', name: 'Pendiente de Aprobar'},
            {code:'APPROVED', name: "Aprobado"},
            {code:'REJECTED', name: "Rechazado"}
        ],
        en: [
            {code:'ALL', name: 'Any Status'},
            {code:'PENDINGAPP', name: 'Approval Pending'},
            {code:'APPROVED', name: "Approved"},
            {code:'REJECTED', name: "Rejected"}
        ]
    }
export default certificateStatusRA;